import { TFunction } from "i18next";
import { RentCollectionItem } from "~/types/finance";
import { convertCurrencyFromLowest } from "~/utils/finance/finance";
import { formatMoney } from "~/utils/finance/money";

export const formatRentAmount = (amount: number) =>
  formatMoney(convertCurrencyFromLowest(amount));

export const sumBalanceDue = (items: RentCollectionItem[]) =>
  items.reduce((sum, item) => sum + item.balanceDue, 0);

export const getTenantDisplayName = (
  item: RentCollectionItem,
  t?: TFunction<"translation">,
) => {
  if (item.tenantResolved === false) {
    return t?.("Unavailable") ?? "N/A";
  }
  return (
    [item.tenant?.firstName, item.tenant?.lastName].filter(Boolean).join(" ") ||
    item.tenant?.id ||
    (t?.("Unavailable") ?? "N/A")
  );
};

export const filterRentCollectionForPeriod = (
  items: RentCollectionItem[],
  month: number,
  year: number,
) =>
  items.filter(
    (item) =>
      Number(item.month) === Number(month) && Number(item.year) === Number(year),
  );

export const renderInProgressStatus = (
  t: TFunction<"translation">,
  record: RentCollectionItem,
) => {
  switch (record.inProgressReason) {
    case "processing":
      return t("Processing");
    case "pending":
      return t("Pending");
    case "partial":
      return t("Partial");
    default:
      return t("Unavailable");
  }
};

export const buildRentPeriodLabel = (
  t: TFunction<"translation">,
  month: number,
  year: number,
  monthNames: string[],
) => {
  const monthLabel = monthNames[month] ?? String(month + 1);
  return `${monthLabel} ${year}`;
};
